import { z } from 'zod';
export const publicTypographyPackSchema = z.enum(['active', 'editorial', 'humanist']);
export const storefrontTemplateSchema = z.enum(['catalogue', 'portfolio', 'wellness']);
export const linkPageStyleSchema = z.enum(['catalogue', 'focused', 'compact', 'immersive', 'sport', 'editorial', 'vivid', 'graphic', 'gallery', 'concierge', 'schedule', 'social', 'studio', 'menu', 'bloom', 'table', 'olive', 'form', 'roast', 'ember', 'satin', 'court', 'flow', 'gather', 'frame', 'kind']);
export const linkPageThemeSchema = z.object({
    surface: z.enum(['light', 'dark', 'brand', 'photo']),
    linkShape: z.enum(['square', 'rounded', 'pill']),
    linkStyle: z.enum(['solid', 'outline', 'soft']),
    density: z.enum(['airy', 'balanced', 'compact']),
    socialStyle: z.enum(['icons', 'labels', 'cards']).default('icons'),
    socialColor: z.enum(['brand', 'accent', 'mono']).default('accent'),
    backgroundStrength: z.enum(['soft', 'visible', 'bold']).default('visible'),
});
export const defaultLinkPageTheme = {
    surface: 'light',
    linkShape: 'rounded',
    linkStyle: 'solid',
    density: 'balanced',
    socialStyle: 'icons',
    socialColor: 'accent',
    backgroundStrength: 'visible',
};
export * from './public-links.js';
//# sourceMappingURL=public-page-design.js.map